import { objectOf, arrayOf, anyOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult } from "./types";

const isNull = (v: unknown): v is null => v === null;

const isDecisioningStudioDimensionSchemaField = objectOf({
  sort: number,
  column: string,
  category: string,
  encoding: anyOf(string, isNull),
  data_type: string,
  description: anyOf(string, isNull),
  default_value: anyOf(string, number, boolean, isNull),
  encoding_order: anyOf(string, isNull),
  editable_by: maybe(arrayOf(string)),
  display_name: maybe(string, true),
});

const isDecisioningStudioDimensionSchema = objectOf({
  slug: string,
  name: string,
  description: string,
  fields: arrayOf(isDecisioningStudioDimensionSchemaField),
  action_count: number,
  active_actions: number,
  inactive_actions: number,
  created_at: string,
  updated_at: string,
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult = objectOf({
  data: isDecisioningStudioDimensionSchema,
  meta: isNull,
}) as (value: unknown) => value is GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult;
